/**
 * Paged carousel counters for Zaynoo sliders.
 * Uses zaynoo-slider-counter-* classes so Dawn SliderComponent does not overwrite totals.
 */
class ZaynooPagedSlider {
  constructor(root) {
    this.root = root;
    this.slider = root.querySelector('[id^="Slider-"]');
    this.prevButton = root.querySelector('button[name="previous"]');
    this.nextButton = root.querySelector('button[name="next"]');
    this.currentEl = root.querySelector('.zaynoo-slider-counter--current');
    this.totalEl = root.querySelector('.zaynoo-slider-counter--total');

    if (!this.slider || !this.prevButton || !this.nextButton || !this.currentEl || !this.totalEl) {
      return;
    }

    this.mobileStep = Number(root.dataset.zaynooPagedSliderMobileStep || 1);
    this.tabletStep = Number(root.dataset.zaynooPagedSliderTabletStep || 0);
    this.tabletMin = Number(root.dataset.zaynooPagedSliderTabletMin || 750);
    this.tabletMax = Number(root.dataset.zaynooPagedSliderTabletMax || 989);
    this.desktopStep = Number(root.dataset.zaynooPagedSliderDesktopStep || 0);
    this.desktopMin = Number(root.dataset.zaynooPagedSliderDesktopMin || 990);
    this.rafId = null;

    this.onResize = () => this.queueRefresh();
    window.addEventListener('resize', this.onResize);

    this.resizeObserver = new ResizeObserver(() => this.queueRefresh());
    this.resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', () => this.queueRefresh());
    this.prevButton.addEventListener('click', () => setTimeout(() => this.queueRefresh(), 10));
    this.nextButton.addEventListener('click', () => setTimeout(() => this.queueRefresh(), 10));
    this.queueRefresh();
  }

  slides() {
    return Array.from(this.slider.querySelectorAll('.slider__slide')).filter((el) => el.clientWidth > 0);
  }

  getStep() {
    const width = window.innerWidth;

    if (width >= this.desktopMin && this.desktopStep > 1) {
      return this.desktopStep;
    }

    if (width >= this.tabletMin && width <= this.tabletMax && this.tabletStep > 1) {
      return this.tabletStep;
    }

    return this.mobileStep;
  }

  refresh() {
    const items = this.slides();
    if (!items.length) return;

    const step = this.getStep();
    const totalPages = Math.max(1, Math.ceil(items.length / step));
    const itemOffset = items[1] ? items[1].offsetLeft - items[0].offsetLeft : items[0].clientWidth;
    const pageWidth = Math.max(1, itemOffset * step);
    const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
    let currentPage = Math.min(totalPages, Math.max(1, Math.floor((this.slider.scrollLeft + 1) / pageWidth) + 1));

    if (maxScroll > 0 && this.slider.scrollLeft >= maxScroll - 2) {
      currentPage = totalPages;
    }

    this.prevButton.dataset.step = String(step);
    this.nextButton.dataset.step = String(step);
    this.currentEl.textContent = String(currentPage);
    this.totalEl.textContent = String(totalPages);
  }

  queueRefresh() {
    cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(() => this.refresh());
  }
}

function initZaynooPagedSliders() {
  document.querySelectorAll('[data-zaynoo-paged-slider]').forEach((root) => {
    if (root.dataset.zaynooPagedSliderInitialized === 'true') return;
    root.dataset.zaynooPagedSliderInitialized = 'true';
    new ZaynooPagedSlider(root);
  });
}

function observeDynamicPagedSliders() {
  document.querySelectorAll('product-recommendations').forEach((el) => {
    if (el.dataset.zaynooPagedSliderObserved === 'true') return;
    el.dataset.zaynooPagedSliderObserved = 'true';
    new MutationObserver(() => initZaynooPagedSliders()).observe(el, { childList: true, subtree: true });
  });
}

function bootZaynooPagedSliders() {
  initZaynooPagedSliders();
  observeDynamicPagedSliders();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootZaynooPagedSliders);
} else {
  bootZaynooPagedSliders();
}

document.addEventListener('shopify:section:load', bootZaynooPagedSliders);
